import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Button} from 'views/components';
import {AccessTime as AccessTimeIcon, Edit as EditIcon} from 'views/icons';
import {Translate, translate, Map} from 'views/module';

import TimelineCard from './TimelineCard';
import moment from 'moment';

const ShiftClockedIn = (props) => {
  const {clockIn, caregiverData, setModel} = props;

  const timeString = moment(clockIn.createdAt).format('LLL');

  const actualClockinTimeFormatted = clockIn.data.actualClockinTimeFormatted;
  const suggestedClockinTimeFormatted = clockIn.data.suggestedClockinTimeFormatted;

  // Format data if present
  const actualClockinTime = actualClockinTimeFormatted ? moment(actualClockinTimeFormatted).format('h:mm A') : null;
  const suggestedClockinTime = suggestedClockinTimeFormatted ? moment(suggestedClockinTimeFormatted).format('h:mm A') : null;
  const location = clockIn.data.location;
  const notes = clockIn.data.additionalNotes || translate('schedule.eventDetail.EventTimelineSection.ShiftClockedIn.NoNotes');

  const onClickEditClockIn = () => {
    setModel('UPDATE_CAREGIVER_CLOCK_IN');
  };

  return (
    <TimelineCard
      timeString={timeString}
      icon={AccessTimeIcon}
      iconColor="#7b1fa2"
      timeBg="#e0e0e0"
      title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.Title' />}
    >
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          <Translate
            expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.Description'
            substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
          />
        </Typography>

        {
          actualClockinTimeFormatted && suggestedClockinTimeFormatted &&
          (
            <Stack spacing={1}>
              {/* Clock out timings */}
              <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={0.5}
                alignItems={{xs: 'flex-start', sm: 'center'}}
                flexWrap="nowrap"
              >
                <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'} whiteSpace="nowrap">
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.ClockinTime'/>
                </Typography>
                <Typography color="text.secondary" fontSize={'14px'} whiteSpace="nowrap">
                  {actualClockinTime}
                </Typography>
              </Stack>
              <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={1}
                alignItems={{xs: 'flex-start', sm: 'center'}}
                flexWrap="nowrap"
              >
                <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'} whiteSpace="nowrap">
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.EditedClockinTime'/>
                </Typography>
                <Typography color="text.secondary" fontSize={'14px'} whiteSpace="nowrap">
                  {suggestedClockinTime}
                </Typography>
                <Button
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => onClickEditClockIn()}
                  sx={{
                    'color': 'black',
                    'backgroundColor': '#ffffff',
                    'border': '1px solid #e0e0e0',
                    'borderRadius': 2,
                    'textTransform': 'none',
                    'fontSize': '12px',
                    'fontWeight': 'normal',
                    '& .MuiButton-startIcon': {
                      marginRight: '4px',
                    },
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                      borderColor: '#d0d0d0',
                    },
                  }}
                >
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.EditClockinButton' />
                </Button>
              </Stack>

              {/* Notes */}
              <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={1}
                alignItems={{xs: 'flex-start', sm: 'center'}}
                flexWrap="nowrap"
              >
                <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'}>
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.Notes'/>
                </Typography>
                <Typography color="text.secondary" fontSize={'14px'}>{notes}</Typography>
              </Stack>

              {/* Location Data */}
              <Typography fontWeight="bold" textAlign={'left'} fontSize={'14px'}>
                <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.Location'/>
              </Typography>
              {
                location ?
                <Map height={'200px'} width={'95%'} coordinates={[location.latitude, location.longitude]} /> :
                <Typography color="text.secondary" fontSize={'14px'}>
                  <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftClockedIn.NoLocation'/>
                </Typography>
              }
            </Stack>
          )
        }
      </Stack>
    </TimelineCard>
  );
};

ShiftClockedIn.propTypes = {
  clockIn: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    data: PropTypes.shape({
      actualClockinTimeFormatted: PropTypes.string,
      suggestedClockinTimeFormatted: PropTypes.string,
      location: PropTypes.object,
      additionalNotes: PropTypes.string,
    }),
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  setModel: PropTypes.func.isRequired,
};

export default ShiftClockedIn;
